import { Button, Card, ControlledInput, DataTable } from "@dune/ui";
import { RefreshCcw02 } from "@untitled-ui/icons-react";
import { FileWarning } from "lucide-react";
import { useFormContext, useWatch } from "react-hook-form";
import { useGetOriasDetails } from "../../../../../../api/mutations/orias.mutations";
import { categoriesColumns } from "../../../../../../auth/register/register-second-step-broker/categoriesColumns";

export const OriasDetails: React.FC = () => {
	const { control, setValue } = useFormContext();

	const attachedCategories = useWatch({ control, name: "categories" });
	const oriasNumber = useWatch({ control, name: "oriasNumber" });
	const { refetch, isFetching } = useGetOriasDetails(oriasNumber, false);

	const handleRefresh = async () => {
		if (!oriasNumber) return;
		const result = await refetch();
		const data = result.data;
		if (data) {
			const newCategories = data.registrations.map((registration) => ({
				category: registration.categoryName,
				status:
					registration.status === "INSCRIT" ? "REGISTERED" : "NOT_REGISTERED",
				registrationDate: registration.registrationDate,
				categoryDeletionDate: registration.deletionDate,
				fundCollection: registration.collectFunds,
				mandants: "",
			}));
			setValue("categories", newCategories);
		}
	};

	return (
		<div className="flex flex-row gap-4 pt-3">
			<div className="flex flex-col gap-4 pb-3 w-full">
				<div className="flex flex-row justify-between">
					<div className="text-text-main-blue  font-semibold">ORIAS</div>
					<Button onClick={handleRefresh} disabled={!oriasNumber || isFetching}>
						<RefreshCcw02 />
						{isFetching ? "Chargement..." : "Rafraichir API"}
					</Button>
				</div>
				<Card className="p-6 flex flex-col gap-4 overflow-auto text-text-secondary-blue">
					<div className="flex flex-col gap-4">
						<div className="flex flex-col items-start gap-3 w-full">
							<ControlledInput
								label="Numéro ORIAS"
								control={control}
								name="oriasNumber"
							/>
						</div>
						<div className="flex flex-col items-start gap-3 w-full">
							<div className="text-text-secondary-blue">Catégories</div>
							<DataTable
								columns={categoriesColumns}
								data={attachedCategories}
								noResultsText="Aucune catégorie trouvée"
								icon={FileWarning}
								variant="gray-no-pagination"
							/>
						</div>
					</div>
				</Card>
			</div>
		</div>
	);
};
